import { makeStyles } from 'tss-react/mui';
import {
  BACKGROUND_BLUE,
  PRIMARY_WHITE,
  PURPLE_TRANSPARENT,
  SECONDARY_BLUE_2_TRANSPARENT,
  SECONDARY_BLUE_2_TRANSPARENT_15,
  SHADOW_GREY,
  TRANSPARENT_BLACK_20,
  TRANSPARENT_BLACK_50,
  WHITE,
} from 'utilities/colors';

export const useTeamMembersButtonStyles = makeStyles()(
  (theme, { isActive }) => ({
    teamButton: {
      boxShadow: `0 0 1.25rem 0.75rem ${SHADOW_GREY}`,
      border: `1px solid ${TRANSPARENT_BLACK_20}`,
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 1rem',
      borderRadius: '0.25rem',
      backgroundColor: isActive ? BACKGROUND_BLUE : WHITE,
      color: TRANSPARENT_BLACK_50,
      height: '3rem',
      width: '14rem',
      alignItems: 'right',
      '&:hover': {
        backgroundColor: isActive
          ? SECONDARY_BLUE_2_TRANSPARENT
          : PRIMARY_WHITE,
      },
    },
    teamIcon: {
      marginRight: '0.5rem',
    },
    teamIconBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '0.25rem',
      padding: '0.15rem',
      marginRight: '0.5rem',
      backgroundColor: isActive
        ? SECONDARY_BLUE_2_TRANSPARENT_15
        : PURPLE_TRANSPARENT,
    },
    teamButtonTitle: {
      fontFamily: 'Roboto',
      fontWeight: 500,
      letterSpacing: '0.075em',
      textTransform: 'uppercase',
    },
    notificationButton: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      marginLeft: '0.5rem',
      alignItems: 'center',
      width: '3rem',
      height: '3rem',
      backgroundColor: 'white',
      borderRadius: '0.25rem',
      border: `1px solid ${TRANSPARENT_BLACK_20}`,
      '&:hover': {
        backgroundColor: PRIMARY_WHITE,
        cursor: 'pointer',
      },
    },
    notificationBubble: {
      backgroundColor: theme.palette.primary.main,
      color: PRIMARY_WHITE,
      borderRadius: '50%',
      width: '1.25rem',
      height: '1.25rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '0.875rem',
      fontWeight: 500,
      position: 'absolute',
      right: '-0.5rem',
      top: '-0.5rem',
    },
  }),
);
